export const navlinksdata = [
  {
    _id: 1001,
    title: "Home Run",
    link: "home",
  },
  {
    _id: 1002,
    title: "Who's Phil?",
    link: "who",
  },
  {
    _id: 1003,
    title: "Playfools",
    link: "playfools",
  },
  {
    _id: 1004,
    title: "Page Me!",
    link: "pageme",
  },
];
